(function () {
  var videos = Array.prototype.slice.call(document.querySelectorAll('.inline-video'));

  if (videos.length > 0) {
    for (var i = 0; i < videos.length; i += 1) {
      var video = videos[i];
      var videoWidth = video.offsetWidth;
      var videoHeight = video.offsetHeight;

      video.addEventListener('click', function () {
        video.querySelector('.inline-video__container').style.display = 'none';
        video.querySelector('.inline-video__video').style.display = 'block';
        video.querySelector('.inline-video__video iframe').style.maxHight = videoHeight + 'px';
        video.querySelector('.inline-video__video iframe').style.maxWidth = videoWidth + 'px';
      });
    }
  }
})();